import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const HOUSEBOATS = [
  { name:'Royal Heritage Suite', lake:'Dal Lake', category:'Super Deluxe', price:6999, amenities:['Lake View','WiFi','AC','Heater','Hot Water','Luxury Bedroom','Private Balcony','Room Service','Shikara Ride'], img:'https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=800&q=80', rating:4.9, reviews:124, badge:'Most Popular', capacity:'2-4 guests', size:'3 BHK' },
  { name:'Nagin Pearl Palace',   lake:'Nagin Lake', category:'Premium', price:8999, amenities:['Panoramic View','WiFi','AC','Hot Water','Dining Hall','Shikara Ride','Private Deck','Butler Service'], img:'https://images.unsplash.com/photo-1614591276564-7b3e69347a48?w=800&q=80', rating:4.8, reviews:89, badge:'Premium Pick', capacity:'2-6 guests', size:'4 BHK' },
  { name:'Lake Garden Retreat',  lake:'Dal Lake', category:'Deluxe', price:4499, amenities:['Garden View','WiFi','Heater','Hot Water','Breakfast Included','Shikara Ride'], img:'https://images.unsplash.com/photo-1656343058836-ebc766a32a51?w=800&q=80', rating:4.7, reviews:67, badge:'Best Value', capacity:'2 guests', size:'1 BHK' },
  { name:'Shalimar Floating Palace', lake:'Dal Lake', category:'Super Premium', price:12999, amenities:['360° Lake View','WiFi','AC','Jacuzzi','Private Chef','Butler','Helipad Access','Luxury Boat'], img:'https://images.unsplash.com/photo-1596083332905-666e9acf8807?w=800&q=80', rating:5.0, reviews:42, badge:'Ultra Luxury', capacity:'2-4 guests', size:'3 BHK' },
  { name:'Gulshan Houseboat',    lake:'Nagin Lake', category:'Standard', price:2999, amenities:['Lake View','WiFi','Hot Water','Breakfast','Shikara Ride'], img:'https://images.unsplash.com/photo-1569852837213-00d97a707a83?w=800&q=80', rating:4.6, reviews:156, badge:'Budget Friendly', capacity:'2 guests', size:'1 BHK' },
  { name:'Emperor\'s Waterfront', lake:'Dal Lake', category:'Premium', price:9499, amenities:['Sunset View','WiFi','AC','Heater','Dining','Private Balcony','Shikara Ride','24h Service'], img:'https://images.unsplash.com/photo-1708070642298-166c0af7a12d?w=800&q=80', rating:4.9, reviews:73, badge:'Highly Rated', capacity:'4-6 guests', size:'3 BHK' },
];

const CATEGORIES = ['All','Standard','Deluxe','Super Deluxe','Premium','Super Premium'];

export default function Houseboats() {
  const [filter, setFilter] = useState('All');
  const [showForm, setShowForm] = useState(null);
  const [form, setForm] = useState({ name:'', email:'', phone:'', date:'', nights:3, guests:2 });

  const filtered = filter === 'All' ? HOUSEBOATS : HOUSEBOATS.filter(h => h.category === filter);

  return (
    <div>
      {/* Hero */}
      <div style={{ position:'relative', height:500, overflow:'hidden' }}>
        <img src="https://images.unsplash.com/photo-1596083332905-666e9acf8807?w=1600&q=85" alt="Dal Lake Houseboats" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, rgba(16,37,66,0.40) 0%, rgba(16,37,66,0.75) 100%)' }} />
        <div className="container" style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', justifyContent:'center', zIndex:1, paddingTop:72 }}>
          <div className="breadcrumb" style={{ justifyContent:'flex-start', marginBottom:'1.25rem' }}>
            <Link to="/">Home</Link><span className="breadcrumb-sep">›</span><span>Houseboats</span>
          </div>
          <span style={{ display:'inline-flex', alignItems:'center', gap:'0.5rem', fontFamily:"'Poppins',sans-serif", fontSize:'0.78rem', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', color:'var(--accent)', marginBottom:'1rem' }}>
            <span style={{ width:24, height:2, background:'var(--accent)', display:'inline-block' }} /> Luxury Houseboats
          </span>
          <h1 style={{ color:'#fff', fontFamily:"'Playfair Display',serif", fontSize:'clamp(2rem,4.5vw,3.4rem)', lineHeight:1.15, maxWidth:620, marginBottom:'1rem' }}>
            Sleep on the Magical<br/><span style={{ fontStyle:'italic', color:'var(--accent)' }}>Dal Lake</span>
          </h1>
          <p style={{ color:'rgba(255,255,255,0.85)', maxWidth:500, lineHeight:1.75, fontSize:'1.05rem' }}>
            Wake up to misty mountains reflected on still waters. Our curated collection of luxury houseboats redefines comfort on Kashmir's legendary lakes.
          </p>
        </div>
      </div>

      <section className="section" style={{ background:'var(--bg)', paddingTop:'3rem' }}>
        <div className="container">

          {/* Filter */}
          <div style={{ display:'flex', gap:'0.5rem', flexWrap:'wrap', marginBottom:'2.5rem' }}>
            {CATEGORIES.map(c => (
              <button key={c} onClick={() => setFilter(c)} className={`btn btn-sm${filter===c ? ' btn-primary' : ' btn-outline'}`}>{c}</button>
            ))}
          </div>

          {/* Grid */}
          <div className="grid-3" style={{ gap:'2rem' }}>
            {filtered.map((h, i) => (
              <div key={i} className="houseboat-card">
                <div className="houseboat-img">
                  <img src={h.img} alt={h.name} loading="lazy" />
                  <div style={{ position:'absolute', top:'1rem', left:'1rem' }}>
                    <span className="badge badge-accent">{h.badge}</span>
                  </div>
                  <div style={{ position:'absolute', top:'1rem', right:'1rem' }}>
                    <span className="badge badge-white">{h.category}</span>
                  </div>
                </div>
                <div className="houseboat-body">
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'0.4rem' }}>
                    <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.15rem', color:'var(--heading)', flex:1 }}>{h.name}</h3>
                  </div>
                  <p style={{ fontSize:'0.82rem', color:'var(--muted)', marginBottom:'0.5rem' }}>📍 {h.lake} · {h.size} · {h.capacity}</p>
                  <div style={{ display:'flex', gap:'0.35rem', alignItems:'center', marginBottom:'0.85rem' }}>
                    {Array(5).fill(0).map((_,j) => <span key={j} style={{ color: j < Math.floor(h.rating) ? '#F59E0B' : 'var(--border)', fontSize:'0.9rem' }}>★</span>)}
                    <span style={{ fontWeight:700, fontSize:'0.85rem', color:'var(--heading)', marginLeft:'0.2rem' }}>{h.rating}</span>
                    <span style={{ color:'var(--muted)', fontSize:'0.8rem' }}>({h.reviews} reviews)</span>
                  </div>
                  <div className="houseboat-amenities">
                    {h.amenities.slice(0,5).map((a,j) => <span key={j} className="amenity-tag">{a}</span>)}
                    {h.amenities.length > 5 && <span className="amenity-tag">+{h.amenities.length-5} more</span>}
                  </div>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', paddingTop:'1rem', borderTop:'1px solid var(--border)' }}>
                    <div>
                      <div style={{ fontWeight:800, fontSize:'1.25rem', color:'var(--primary)', fontFamily:"'Poppins',sans-serif" }}>₹{h.price.toLocaleString('en-IN')}</div>
                      <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>per night</div>
                    </div>
                    <button className="btn btn-secondary" onClick={() => setShowForm(h.name)}>Book Now</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Houseboat */}
      <section className="section" style={{ background:'var(--dark)', position:'relative', overflow:'hidden' }}>
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="section-header text-center">
            <h2 style={{ color:'#fff', fontFamily:"'Playfair Display',serif" }}>The Houseboat Experience</h2>
            <div className="divider divider-center" />
            <p style={{ color:'rgba(255,255,255,0.75)', maxWidth:540, margin:'0 auto 3rem', lineHeight:1.7 }}>Staying on a Kashmir houseboat is not just accommodation — it's an immersion into a centuries-old tradition.</p>
          </div>
          <div className="grid-4" style={{ gap:'1.5rem' }}>
            {[
              { icon:'🌅', title:'Sunrise on the Lake', desc:'Wake up to golden light on still waters, surrounded by floating flower gardens.' },
              { icon:'🛶', title:'Personal Shikara', desc:'Your own traditional Shikara boat for sunset rides and morning market trips.' },
              { icon:'🍽️', title:'Wazwan Dining', desc:'Authentic Kashmiri cuisine served onboard — Rogan Josh, Dum Aloo, and more.' },
              { icon:'🏔️', title:'Mountain Views', desc:'Every window frames a postcard — snow-capped Zabarwan mountains reflected in the lake.' },
            ].map((f,i) => (
              <div key={i} style={{ background:'rgba(255,255,255,0.07)', backdropFilter:'blur(12px)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:'var(--radius-lg)', padding:'1.75rem', textAlign:'center' }}>
                <div style={{ fontSize:'2.5rem', marginBottom:'1rem' }}>{f.icon}</div>
                <h4 style={{ fontFamily:"'Playfair Display',serif", color:'#fff', marginBottom:'0.5rem' }}>{f.title}</h4>
                <p style={{ fontSize:'0.88rem', color:'rgba(255,255,255,0.70)', lineHeight:1.7, margin:0 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      {showForm && (
        <div style={{ position:'fixed', inset:0, zIndex:1000, background:'rgba(16,37,66,0.65)', backdropFilter:'blur(8px)', display:'flex', alignItems:'center', justifyContent:'center', padding:'1.5rem' }} onClick={() => setShowForm(null)}>
          <div style={{ background:'#fff', borderRadius:'var(--radius-xl)', padding:'2.5rem', maxWidth:480, width:'100%', boxShadow:'var(--shadow-xl)' }} onClick={e => e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
              <h3 style={{ fontFamily:"'Playfair Display',serif", color:'var(--heading)' }}>Book {showForm}</h3>
              <button onClick={() => setShowForm(null)} style={{ width:34, height:34, borderRadius:8, background:'var(--bg)', border:'none', cursor:'pointer', fontSize:'1rem' }}>✕</button>
            </div>
            <form onSubmit={e => { e.preventDefault(); setShowForm(null); alert('Booking request sent! We\'ll contact you within 2 hours.'); }}>
              <div style={{ marginBottom:'0.9rem' }}>
                <label className="input-label">Full Name *</label>
                <input className="input" required placeholder="Your name" value={form.name} onChange={e => setForm(f => ({...f, name:e.target.value}))} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0.75rem', marginBottom:'0.9rem' }}>
                <div>
                  <label className="input-label">Email *</label>
                  <input className="input" type="email" required placeholder="email@example.com" value={form.email} onChange={e => setForm(f => ({...f, email:e.target.value}))} />
                </div>
                <div>
                  <label className="input-label">Phone</label>
                  <input className="input" placeholder="+91 xxxxx xxxxx" value={form.phone} onChange={e => setForm(f => ({...f, phone:e.target.value}))} />
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'0.75rem', marginBottom:'1.5rem' }}>
                <div>
                  <label className="input-label">Check-in</label>
                  <input className="input" type="date" value={form.date} onChange={e => setForm(f => ({...f, date:e.target.value}))} />
                </div>
                <div>
                  <label className="input-label">Nights</label>
                  <input className="input" type="number" min="1" value={form.nights} onChange={e => setForm(f => ({...f, nights:e.target.value}))} />
                </div>
                <div>
                  <label className="input-label">Guests</label>
                  <input className="input" type="number" min="1" value={form.guests} onChange={e => setForm(f => ({...f, guests:e.target.value}))} />
                </div>
              </div>
              <button type="submit" className="btn btn-primary btn-lg w-full" style={{ justifyContent:'center' }}>Confirm Booking Request</button>
            </form>
          </div>
        </div>
      )}

      <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="whatsapp-fab">💬</a>
    </div>
  );
}
